import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { Section } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { StratoButton } from "@/components/common/StratoButton";
import { Reveal } from "@/components/common/Reveal";
import { CONTACT } from "@/content/pagesContent";

const EMAIL = "stratolab3d.mc@gmail.com";

export default function Contatti() {
  return (
    <SiteLayout>
      <PageHero
        testId="contatti-page"
        micro={CONTACT.microLabel}
        title={CONTACT.title}
        description={CONTACT.description}
      />

      <Section id="contact-section" tone="offwhite">
        <div className="mx-auto max-w-2xl">
          <Reveal>
            <div
              data-testid="contact-email-card"
              className="rounded-2xl border border-strato-gray-100 bg-strato-white p-6 shadow-soft"
            >
              <div className="flex items-center gap-4">
                <span className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-xl border border-strato-gray-100 bg-strato-gray-50 text-strato-blue">
                  <Mail className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <div className="min-w-0">
                  <MicroLabel className="text-muted-foreground">SCRIVICI</MicroLabel>
                  <a
                    href={`mailto:${EMAIL}`}
                    data-testid="contact-email-link"
                    className="mt-0.5 block truncate text-base font-medium text-strato-graphite transition-colors hover:text-strato-blue sm:text-lg"
                  >
                    {EMAIL}
                  </a>
                </div>
              </div>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <StratoButton as={Link} to="/preventivo" data-testid="contact-quote-cta">
                  Avvia il preventivo
                  <ArrowRight className="h-4 w-4" />
                </StratoButton>
                <StratoButton
                  as={Link}
                  to="/come-funziona"
                  variant="secondary"
                  data-testid="contact-how-link"
                >
                  Come funziona
                </StratoButton>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.08}>
            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {CONTACT.info.map((item) => (
                <div
                  key={item.label}
                  className="rounded-xl border border-strato-gray-100 bg-strato-white px-4 py-3"
                >
                  <MicroLabel className="text-muted-foreground">{item.label}</MicroLabel>
                  <p className="mt-1 text-sm font-medium text-strato-graphite">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </Section>
    </SiteLayout>
  );
}
